<template>
    <div class="aprh__authentication__reset-password">
        <div class="aprh__authentication__form__description">{{ $t('authentication.passwordRequirements') }}</div>
        <base-password
            :input="input"
            class="aprh__authentication__form__field"
            :settings="{
                label: { class: 'capitalize', text: $t('global.password') },
                input: {
                    name: 'password',
                    class: 'aprh__authentication__form__field__input',
                    placeholder: $t('global.password'),
                    browserAutocomplete: 'new-password',
                    fileValidation: 'password',
                    errors: [{
                        type: 'validateStrenghtPassword', warning: $t('error.password')
                    }],
                    isMissing: errors.missing.password,
                    noListener: true
                }
            }"
        />
        <base-password
            :input="input"
            class="aprh__authentication__form__field"
            :settings="{
                label: { class: 'capitalize', text: $t('global.confirmPassword') },
                input: {
                    name: 'confirmPassword',
                    class: 'aprh__authentication__form__field__input',
                    placeholder: $t('global.confirmPassword'),
                    browserAutocomplete: 'confirm-password',
                    fileValidation: 'confirmPassword',
                    errors: [{
                        type: 'sameAsPassword', warning: $t('error.confirmPassword')
                    }],
                    validationParameter: payload.password,
                    isMissing: errors.missing.confirmPassword,
                    noListener: true
                }
            }"
        />
    </div>
</template>

<script>
// store
// eslint-disable-next-line
import { mapState } from '@/hooks/use-store';

export default {
    components: {
        BasePassword: () => import( /* webpackChunkName: 'BasePassword' */ '@/components/bundles/fields/BasePassword' )
    },
    props: {
        input: Function
    },
    setup ( _, { root: { $router, $route } }) {
        // validação se o utilizador acedeu a página
        // com signature. Caso não tenha, é redirecionado
        // para a página de login.
        if ( !$route.query.signature )
            $router.push({ name: 'login' });

        const payload = mapState({ module: 'storePayload', key: 'payload' });
        const errors = mapState({ module: 'storePayload', key: 'errors' });

        return { payload, errors };
    }
};
</script>